// extracted by mini-css-extract-plugin
export default {"stripesBackground":"DefaultImage__stripesBackground___eGyS9","rounded":"DefaultImage__rounded___b528U"};